/**
 * Language Card Component
 * Language preference selection
 */

import { Globe } from 'lucide-react';
import { useLanguage } from '../../../../contexts/LanguageContext';

export function LanguageCard() {
  const { t, language, setLanguage, languages } = useLanguage();

  return (
    <div className="bg-white border border-gray-200 rounded-2xl overflow-hidden hover:shadow-lg hover:border-primary-200 transition-all duration-200">
      {/* Header */}
      <div className="px-6 py-4 border-b border-gray-100">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-green-100 rounded-lg">
            <Globe className="w-5 h-5 text-green-600" />
          </div>
          <div>
            <h2 className="font-semibold text-gray-900">
              {t('settings.language.title', 'Language')}
            </h2>
            <p className="text-sm text-gray-500">
              {t('settings.language.subtitle', 'Choose your preferred language')}
            </p>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="p-6">
        <div className="max-w-md">
          <label htmlFor="language-select" className="block text-sm font-medium text-gray-700 mb-1">
            {t('settings.language.displayLanguage', 'Display Language')}
          </label>
          <select
            id="language-select"
            value={language}
            onChange={(e) => setLanguage(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-600 focus:border-transparent bg-white"
          >
            {languages.map((lang) => (
              <option key={lang.code} value={lang.code}>
                {lang.nativeName} {lang.nativeName !== lang.name && `(${lang.name})`}
              </option>
            ))}
          </select>
          <p className="mt-2 text-xs text-gray-500">
            {t('settings.language.description', 'This changes the display language for the website. Your preference is saved automatically.')}
          </p>
        </div>
      </div>
    </div>
  );
}
